export default function ($http) {
    return function (model) {
        return $http({
            method: 'PUT',
            url: '/api/users/changePassword',
            data: model,
            headers: {
                'Content-Type': 'application/json'
            }
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/account/services/changePassword/changePassword.js